<!DOCTYPE html>
<html class="no-js" lang="">

<head>
  <meta charset="utf-8" />
  <meta http-equiv="x-ua-compatible" content="ie=edge" />
  <title>TechEnClutch Solutions</title>
  <meta name="description" content="TechEnClutch Solutions" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
</head>

<body>
  <app-header>
  </app-header>
  <ng-container *ngIf="isApiToken();">
    <router-outlet></router-outlet>
  </ng-container>
  <app-footer [menuData]="menuData">
  </app-footer>
</body>

</html>